var __vue_script__, __vue_template__
require("!!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-22804018&scoped=true!./../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./PlainText.vue")
__vue_script__ = require("!!babel!./../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./PlainText.vue")
__vue_template__ = require("!!vue-html-loader!./../../node_modules/vue-loader/lib/template-rewriter.js?id=_v-22804018!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./PlainText.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) {
(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PlainText.vue
 ** module id = 165
 ** module chunks = 0
 **/